<template>
    <div
        class="input-checkbox"
        @click="toggle()"
        :class="[{ positive: positive }]"
    >
        {{ label }}
    </div>
</template>

<script>
export default {
    props: ['value', 'label'],
    data() {
        return {
            positive: this.value ?? null,
        };
    },
    methods: {
        toggle() {
            this.positive = !this.positive;
            this.$emit('input', this.positive);
        },
    },
};
</script>

<style lang="scss">
.input-checkbox {
    border: 1px solid #c8532b;
    border-radius: 24px;
    color: #c8532b;
    display: inline-block;
    line-height: 46px;
    padding-left: 35px;
    padding-right: 35px;
    margin-right: 20px;
    margin-bottom: 15px;
    cursor: pointer;

    &:hover,
    &.positive {
        background-color: #c8532b;
        color: #fff;
        border-color: #c8532b;
    }
}
</style>
